import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import moment from 'moment';
import CardBox from 'components/CardBox/index';
import { Button } from "@material-ui/core";
import DraftsIcon from '@material-ui/icons/Drafts';
import EditIcon from '@material-ui/icons/Edit';
import { success } from "configs/CustomColors";
const ListCorrigir = ({ data, cancelamento }) => {
  return (
    <List>
      {data.map((item, index) => {
        return (
          <CardBox
            styleName="col-lg-12 col-md-6 col-12"
            cardStyle="p-0"
            heading={""}
            headerOutside
          >
            <ListItem key={item.id}>
              <ListItemAvatar>
                <Avatar>
                  <DraftsIcon color={item.tx_status_venda_nf == '135' ? 'primary' : 'default'} />
                </Avatar>
              </ListItemAvatar>
              <ListItemText style={{ width: "15%" }} className="br-break"
                primary={`${item.nu_nota ? item.nu_nota : '...'}/${item.nu_serie ? item.nu_serie : '...'}`}
                secondary={item.tx_tipo_documento} />
              <ListItemText style={{ width: "15%" }} className="br-break" primary={item.vr_total ? "R$" + item.vr_total : null} />
              <ListItemText style={{ width: "15%" }} className="br-break" primary={item.dt_evento ? moment(item.dt_evento.slice(0, 10)).format("DD/MM/YYYY") : null} />
              <ListItemText style={{ width: "15%" }} className="br-break" primary={item.dt_emissao ? moment(item.dt_emissao.slice(0, 10)).format("DD/MM/YYYY") : null} />
              <ListItemText style={{ width: "15%" }} className="br-break" primary={item.nu_seq_evento} />

              <ListItemSecondaryAction style={{ flexDirection: 'row' }}>
                <Button onClick={() => cancelamento(item.id, item.nu_nota)} startIcon={<EditIcon />} >{item.tx_status_venda_nf === '135' ? 'Reescrever' : 'Escrever'}</Button>
              </ListItemSecondaryAction>
            </ListItem>
          </CardBox>
        );
      })}
    </List>
  );
};

export default ListCorrigir;
